import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Transition from '@ember/routing/-private/transition';
import EnvironmentModel from 'cio/models/environment';
import AnalyticsService from 'cio/services/analytics';
import PlanModel from 'cio/models/plan';
import BillingService from 'cio/services/billing';
import FeaturesService from 'ember-feature-flags/services/features';

export default class IndexRoute extends Route {
  @service store!: DS.Store;
  @service analytics!: AnalyticsService;
  @service billing!: BillingService;
  @service features!: FeaturesService;

  afterModel(resolvedModel: EnvironmentModel, transition: Transition) {
    this.trackObjectTypeListViewed(resolvedModel);

    return super.afterModel(resolvedModel, transition);
  }

  private async trackObjectTypeListViewed(resolvedModel: EnvironmentModel) {
    let objectTypes = resolvedModel.hasMany('objectTypes').value()?.toArray() ?? [];
    let hasObjectsData = false;

    // we need to check if the user has at least one object in any of the object types
    for (let objectType of objectTypes) {
      if (objectType.objectCount > 0) {
        hasObjectsData = true;
        break;
      }
    }

    this.analytics.track('objects', 'object_type_list_viewed', {
      planName: (this.billing.subscription?.belongsTo('plan').value() as PlanModel | null)?.name ?? '',
      hasEnabledObjects: true,
      hasObjectsData,
    });
  }
}
